import { PerfectScrollbarConfigInterface, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { Router } from '@angular/router';
import { NzMessageService, NzModalService } from 'ng-zorro-antd';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { CacheService } from '@delon/cache';
import { PublicParams } from '@shared/utils/publicParams';
import { UserDetailResp } from '@shared/utils/userDetailResp';
import { WsMessage } from './entity/wsMessage';
import { generateFormData } from '@shared/utils/publicMethods';
import { HttpClient } from '@angular/common/http';
import { tzjrwUrls } from '@shared/urls/tzjrwUrls';
import { pyfaUrls } from '@shared/urls/pyfaUrls';
import { DA_SERVICE_TOKEN, ITokenService } from '@delon/auth';
import { ShrAssemblyParams } from '@shared/assembly/shr-assembly/shrAssemblyParams';

@Component({
  selector: 'app-teacher',
  templateUrl: './teacher.component.html',
  styleUrls: ['./teacher.less'],
})
export class TeacherComponent implements OnInit {
  salesData: any[] = new Array(12).fill({}).map((_i, idx) => ({
    x: `${idx + 1}月`,
    y: Math.floor(Math.random() * 1000) + 200,
  }));

  // 审核人弹出框参数信息
  shrParams: ShrAssemblyParams = new ShrAssemblyParams(tzjrwUrls.ShrwUrls.findPageShr, tzjrwUrls.ShrwUrls.updateShzts);
  // 审核人组件信息
  @ViewChild('shrAss', { static: true }) shrAss: any;

  // 查询下一节点审核人参数
  Params: any = {
    openid: '',
    shstatus: 0,
    shyj: '',
    ywlxid: '',
    norder: '',
  };

  msgData = [];
  taskData = [];
  isSpinning: boolean;
  isVisible: boolean;
  title: string;
  content: string;
  creator: any;
  sendTime: any;
  fileName: any;
  httpParams: { fileName: any };
  httpUrl = tzjrwUrls.fileUrls.downloadFile;
  modalContent: any;
  shVisible: boolean;
  statusValue = 1; // 审核状态
  auditOpinion = ''; // 审核意见
  backlogID: string;
  flowImg: string;
  // 流程详情
  detail: any = {};

  ywlxid = '';
  norder: any;
  shrName = '';
  page = 1;
  rows = 10;

  shrData = [];
  totals = '';


  // 学期计划
  xqjhData: [];
  // 各学期学分
  gxqxfData: [];
  // 总学分
  zxfData: [];

  shztType = [
    {
      text: '审核中',
      value: 2,
    },
    {
      text: '同意',
      value: 1,
    },
    {
      text: '不同意',
      value: 0,
    },
  ];

  public config: PerfectScrollbarConfigInterface = {};
  @ViewChild(PerfectScrollbarDirective, { static: true }) directiveRef?: PerfectScrollbarDirective;
  gridStyle = {
    width: '25%',
    textAlign: 'center',
  };
  // 定义websocket
  ws: WebSocket;
  // websocket连接参数
  wsParams: any = {
    // 连接错误次数
    errCount: 0,
    // 连接错误的最大次数
    maxErrCount: 20,
    // 时间遍历对象
    timeOut: '',
    // 断开后重连的时间间隔
    reconnectionTime: 30000,
    // 本地心跳
    timeoutObj: null,
    // 服务器心跳
    serverTimeoutObj: null,
    // 心跳检测时长
    timeout: 30000,
  };

  constructor(
    private message: NzMessageService,
    private router: Router,
    public cacheService: CacheService,
    private http: HttpClient,
    private modal: NzModalService,
    @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService,
  ) {
  }

  toKcInfo() {
    this.message.create('success', '课程信息');
    this.router.navigateByUrl('/xtwh/user.html');
  }

  toCjgl() {
    this.message.create('success', '成绩管理');
  }

  //查看考试信息
  toCkksInfo() {
    this.cacheService.get(PublicParams.cacheUserName).subscribe((res: UserDetailResp) => {
      // 如果是管理员
      if (res.role.includes('管理员')) {
        this.router.navigateByUrl('/kwgl/scksxx.html');
      } else {
        // 否则查询个人
        // this.router.navigateByUrl('/jxap/jsckkb.html');
      }
    });
  }

  toTermFj() {
    this.message.create('success', '学期放假');
  }

  //查看课表
  toCkkcb() {
    this.cacheService.get(PublicParams.cacheUserName).subscribe((res: UserDetailResp) => {
      // 如果是管理员查询课时量统计信息
      if (res.role.includes('管理员')) {
        this.router.navigateByUrl('/jxap/kbscck.html');
      } else {
        // 否则查询个人课时量统计信息
        this.router.navigateByUrl('/jxap/jsckkb.html');
      }
    });
  }

  //评教
  toPj() {
    this.cacheService.get(PublicParams.cacheUserName).subscribe((res: UserDetailResp) => {
      // 如果是管理员查询课时量统计信息
      if (res.role.includes('管理员')) {
        this.router.navigateByUrl('/pjgl/pjxx.html');
      } else {
        // 否则查询个人课时量统计信息
        this.router.navigateByUrl('/pjgl/wdpj.html');
      }
    });
  }

  close(): void {
    this.ws.close();
  }

  // 跳转到查看工作量页面
  viewWorkload() {
    // tslint:disable-next-line: deprecation
    this.cacheService.get(PublicParams.cacheUserName).subscribe((res: UserDetailResp) => {
      // 如果是管理员查询课时量统计信息
      if (res.role.includes('管理员')) {
        this.router.navigateByUrl('/jxyx/ksltj.html');
      } else {
        // 否则查询个人课时量统计信息
        this.router.navigateByUrl('/jxyx/ckgrgzltj.html');
      }
    });
  }

  /**
   * 重置心跳
   */
  heartReset() {
    clearTimeout(this.wsParams.timeoutObj);
    clearTimeout(this.wsParams.serverTimeoutObj);
  }

  /**
   * 心跳检测
   */
  heartCheck() {
    this.wsParams.timeoutObj = setInterval(() => {
      // 这里发送一个心跳，后端收到后，返回一个心跳消息，
      // onmessage拿到返回的心跳就说明连接正常
      this.ws.send('ping');
    }, this.wsParams.timeout);
  }

  /**
   * webSocket连接
   */
  connection(userId: string) {
    let url = window.location.href;
    const host = window.location.host;
    url = url.substring(0, url.indexOf(':', 0));
    let startWsUrl = 'ws://';
    if (url === 'https') {
      startWsUrl = 'wss://';
    }
    try {
      if ('WebSocket' in window) {
        // url: 'ws://222.30.195.31:80/msg_channel',
        this.ws = new WebSocket(startWsUrl + host + '/msg_channel?userId=' + userId);
      } else {
        this.message.create(
          'warning',
          '您的浏览器不支持websocket协议,建议使用新版谷歌、火狐等浏览器，请勿使用IE10以下浏览器，360浏览器请使用极速模式，不要使用兼容模式！',
        );
        return;
      }
      const that = this;
      // tslint:disable-next-line: only-arrow-functions
      this.ws.onopen = function(event) {
        // socket 开启后执行，可以向后端传递信息
        that.wsParams.errCount = 0;
        // 开始心跳检测
        that.heartCheck();
      };
      // event WsMessage类型
      // tslint:disable-next-line: only-arrow-functions
      this.ws.onmessage = function(event) {
        // 后台不接受websocket发送的消息
        // that.ws.send('sonmething');
        // socket 获取后端传递到前端的信息
        const wsMessage = new WsMessage(JSON.parse(event.data));
        if (wsMessage.message) {
          // 忽略心跳
          if (wsMessage.message !== 'connected') {
            console.log('接收到的通知：', wsMessage);
            that.message.create('info', '您有来自' + wsMessage.sender + '的消息：' + wsMessage.message);
          }
        } else if (wsMessage.tital) {
          console.log('接收到的通知：', wsMessage);
          that.message.create('info', '您有来自' + wsMessage.sender + '的消息：' + wsMessage.tital);
        }
      };
      // tslint:disable-next-line: only-arrow-functions
      this.ws.onerror = function(event) {
        // socket error信息
        console.log('连接发生异常....', event);
      };
      // tslint:disable-next-line: only-arrow-functions
      this.ws.onclose = function(event) {
        // socket 关闭后执行
        console.log('连接已断开开始尝试重新连接....', event);
        // tslint:disable-next-line: only-arrow-functions
        that.wsParams.timeOut = setTimeout(function() {
          that.reconnection(userId);
        }, that.wsParams.reconnectionTime);
        // that.reconnection(userId);
      };
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * 重新进行webSocket连接
   */
  reconnection(userId: string) {
    this.wsParams.errCount += 1;
    console.log('正在尝试第' + this.wsParams.errCount + '次重新连接...');
    // 1与服务器已经建立连接
    if (this.wsParams.errCount >= this.wsParams.maxErrCount || this.ws.readyState === 1) {
      clearTimeout(this.wsParams.timeOut);
    } else if (this.ws.readyState === 3) {
      this.heartReset();
      this.connection(userId);
    }
  }

  // 查询通知
  queryInform() {
    this.isSpinning = true;
    const par = generateFormData({
      page: 1,
      rows: 10,
    });
    this.http.post('/tzjrw/receive/getReceives', par).subscribe((response: any) => {
      this.isSpinning = false;
      if (response.err_msg) {
        this.message.create('error', response.err_msg);
        return;
      }
      if (response.total > 5) {
        this.msgData = response.rows.splice(0, 5);
      } else {
        this.msgData = response.rows;
      }
    });
  }

  //   查看通知详情
  viewDetails(data: any) {
    this.isSpinning = true;
    this.http.post('/tzjrw/receive/getDetail', generateFormData({ openid: data.tzxxid })).subscribe((res: any) => {
      this.isSpinning = false;
      console.log(res);
      this.modalContent = '通知详情';
      this.isVisible = true;
      this.title = res.detail.title;
      this.content = res.detail.content;
      this.creator = res.detail.cjrName;
      this.sendTime = res.detail.createtime;
      this.fileName = res.detail.filename;
      this.httpParams = {
        fileName: res.detail.servefilename,
      };
    });
    this.modalContent = '';
  }

  // 查询待办任务
  queryBacklog() {
    this.isSpinning = true;
    const formData = new FormData();
    formData.set('page', '1');
    formData.set('rows', '10');
    this.http.post('/workflow/lcsljdshr/queryToDoFlow', formData).subscribe((response: any) => {
      this.isSpinning = false;
      if (response.err_msg) {
        this.message.create('error', response.err_msg);
        return;
      }
      if (response.total > 5) {
        this.taskData = response.rows.splice(0, 5);
      } else {
        this.taskData = response.rows;
      }
    });
  }

  // 审核
  audit(data: any) {
    this.shVisible = true;
    this.backlogID = data.lcslid;
    this.ywlxid = data.ywlxid;
    this.norder = data.norder;
    this.Params.openid = data.lcslid;
    this.Params.shstatus = this.statusValue;
    this.Params.shyj = data.shyj;
    this.Params.ywlxid = data.ywlxid;
    this.Params.norder = data.norder;
    this.shrAss.params.ywlxid = data.ywlxid;
    this.shrAss.params.norder = data.norder;
    console.log(data);

  }

  // 审核框确认
  auditConfirm() {
    if (this.statusValue == 0) {
      this.saveAudit();
    } else {
      this.findPageShr1();
    }
  }

  findPageShr1() {
    const par = generateFormData({
      ywlxid: this.ywlxid,
      norder: this.norder,
      name: this.shrName,
      page: this.page,
      rows: this.rows,
    });
    this.http.post(tzjrwUrls.ShrwUrls.findPageShr, par).subscribe((response: any) => {
      if (response.err_msg) {
        this.saveAudit();
        return;
      }
      console.log(response);
      this.shrData = response.rows;
      this.totals = response.total;
      // 设置提交流程时的参数
      this.shrAss.submitParams = this.Params;
      // 打开选择审核人弹出框
      this.shrAss.params.visible = true;
      this.shrAss.findPage();
      this.shrData = [];
    });
  }

  /**
   * 流程发起成功事件
   */
  successWorlflow(): void {
    this.shrData = [];
    this.shVisible = false;
  }


  // 保存审核
  saveAudit() {
    this.http
      .post(
        tzjrwUrls.ShrwUrls.updateShzts,
        generateFormData({
          openid: this.backlogID,
          shstatus: this.statusValue,
          shyj: this.auditOpinion,
        }),
      )
      .subscribe((response: any) => {
        if (response.err_code === 2000) {
          this.message.create('success', '审核成功!');
          this.auditOpinion = '';
          this.statusValue = 1;
          this.shVisible = false;
          this.queryBacklog();
        } else {
          this.message.create('error', '审核失败!');
        }
      });
  }

  // 查看流程图
  checkProcess(lct: string) {
    this.flowImg = 'data:image/jpeg;base64,' + lct;
    this.title = '查看流程';
    this.modalContent = '查看流程';
    this.isVisible = true;
  }

  downLoad(fileName) {
    window.open(pyfaUrls.fileUrls.downloadFile + '?fileName=' + fileName + '&token=' + this.tokenService.get().token);
  }

  // 查看待办任务详情
  _viewDetails(data: any) {
    this.title = data.ywlx;
    this.http
      .post(tzjrwUrls.ShrwUrls.findDetail, generateFormData({ ywbdid: data.ywbdid }))
      .subscribe((response: any) => {
        if (response.err_msg) {
          this.message.create('error', response.err_msg);
          return;
        }
        if (data.ywlx === '培养方案申请') {
          this.modalContent = '培养方案申请详情';
          this.detail = response.entity;
          this.getByKctx(this.detail.openid);
          this.getGxqxfjh(this.detail.openid);
          this.findPagePyfaXfsz(this.detail.openid);
          console.log(this.detail);
        }
        if (data.ywlx === '调课申请') {
          this.modalContent = '调课申请详情';
          this.detail = response;
        }
        if (data.ywlx === '借用教室') {
          this.modalContent = '借用教室详情';
          this.detail = response;
        }
        if (data.ywlx === '课程量申请') {
          this.modalContent = '课程量申请详情';
          this.detail = response;
        }
        if (data.ywlx === '缓考免考申请') {
          this.modalContent = '缓考免考申请详情';
          this.detail = response;
        }
        if (data.ywlx === '修改学生成绩申请') {
          this.modalContent = '修改学生成绩详情';
          this.detail = response;
        }
        this.isVisible = true;
      });
  }

  // 查询学期计划
  getByKctx(kctxId): void {
    const par = generateFormData({
      kctxid: kctxId,
    });
    this.http.post(pyfaUrls.pyfaXqjh.getByKctx, par).subscribe((response: any) => {
      this.xqjhData = response.rows;
    });
  }

  // 查询各学期学分计划
  getGxqxfjh(kctxId): void {
    const par = generateFormData({
      kctxId,
    });
    this.http.post(pyfaUrls.xqjhXfsz.selectXqjhXfszByKctxId, par).subscribe((response: any) => {
      console.log(response);
      this.gxqxfData = response;
    });
  }

  // 总学分设置查询
  findPagePyfaXfsz(kctxId) {
    const par = generateFormData({
      kctxid: kctxId,
    });
    this.http.post(pyfaUrls.pyfaXfsz.getXfszs, par).subscribe((response: any) => {
      if (response.rows) {
        this.zxfData = response.rows;
      }
    });
  }

  ngOnInit() {
    this.cacheService.get(PublicParams.cacheUserName).subscribe((res: UserDetailResp) => {
      this.connection(res.user_ID);
    });
    this.queryInform();
    this.queryBacklog();
  }
}
